export function SectionHeading({ eyebrow, title, text, align = "left", as = "h2", id }) {
  const Tag = as;
  return (
    <div className={`max-w-2xl ${align === "center" ? "mx-auto text-center" : ""}`}>
      {eyebrow && <p className="eyebrow mb-4">{eyebrow}</p>}
      <Tag id={id} className="text-2xl font-bold tracking-tight text-eden-text sm:text-3xl lg:text-4xl">{title}</Tag>
      {text && <p className="mt-4 text-base leading-relaxed text-eden-secondary sm:text-lg">{text}</p>}
    </div>
  );
}
